/* SupportCancelConfirm.tsx */
import { useSearchParams } from "react-router-dom";
import { useState } from "react";

export default function SupportCancelConfirm() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState("idle");

  async function handleConfirm() {
    setState("working");
    try {
      const r = await fetch("/api/cancelSubscription", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token }),
      });
      setState(r.ok ? "ok" : "error");
    } catch {
      setState("error");
    }
  }

  if (state === "working")
    return <p className="py-40 text-center animate-pulse">Feldolgozás…</p>;

  if (state === "ok")
    return (
      <main className="py-40 text-center">
        <h1 className="mb-4 text-3xl font-bold text-emerald-600">
          Az előfizetés törölve
        </h1>
        <p>Köszönjük a támogatást, bármikor visszatérhetsz! ❤️</p>
      </main>
    );

  if (state === "error")
    return (
      <main className="py-40 text-center">
        <h1 className="mb-4 text-3xl font-bold text-rose-600">
          Hiba történt
        </h1>
        <p>Ha a link lejárt vagy hibás, írj nekünk: info@balatonte.hu</p>
      </main>
    );

  return (
    <main className="py-40 text-center space-y-6">
      <h1 className="text-3xl font-bold">Biztosan lemondod a havi támogatást?</h1>
      <p>Ez a művelet azonnal megszünteti a következő terhelést.</p>
      <button
        onClick={handleConfirm}
        className="rounded-md bg-rose-600 px-6 py-3 font-semibold text-white hover:bg-rose-700"
      >
        Igen, lemondom
      </button>
    </main>
  );
}
